import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { stepPath } from '../steps';
import { useIntake } from '../context/IntakeContext';

/**
 * Navigate between steps by name, without any step needing to know its number
 * or how the request id rides along in the URL.
 *
 * `go('damage')` → `/:teamId/form/3?q=<id>`
 */
export function useStepNav() {
  const { teamId } = useParams();
  const navigate = useNavigate();
  const { quoteRequestId } = useIntake();

  return useCallback(
    (key, options) => navigate(stepPath(teamId, key, quoteRequestId), options),
    [navigate, teamId, quoteRequestId]
  );
}

export default useStepNav;
